{
    "DataTable_AreYouSure": "Êtes-vous sûr de vouloir supprimer ce qui suit ? \n \n **{}**",
    "NAME": "LanguageDataTable",
    "DataTable_RowsPerPage": "Lignes par page",
    "DataTable_Of": "{}-{} of {}",
    "DataTable_Next": "Page suivante",
    "DataTable_Previous": "Page précédente",
    "DataTable_OfMoreThan": "{}-{} de plus de {}"
}